module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp13_6000.24dc6cb9.png";